import { Box, Button, useTheme } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { leftArrow } from "../../../assets";
import { getContractMetadata } from "../../../state/action-creators/APIActionCreators";
import { tokens } from "../../../theme";
import { getNftContractMetadata } from "../../../utils/wallet/apiHelpers";
import Topbar from "../../global/Topbar";
import PreviewAndSelectedNfts from "./PreviewAndSelectedNfts";

export const SelectedNftStep = ({
  selectedNft,
  setSelectedNft,
  setProfileNfts,
  setStep,
  operation,
  droppedNfts,
  setDroppedNfts,
  scholarAddress,
  setScholarAddress,
  split,
  setSplit,
  currentInstance,
  setCurrentInstance,
  instances,
  addInstance,
  updateInstance,
  removeInstance,
  setInstances,
  type,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [searchVar, setSearchVar] = useState("");
  const [searchShow, setSearchShow] = useState(false);
  const [filteredNfts, setFilteredNfts] = useState([]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        width: "100%",
        // height: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding: "10px 60px 10px 10px",
          borderBottom: "2px solid #E8ECF5",
        }}
      >
        <img
          src={leftArrow}
          alt={"left icon"}
          onClick={() => {
            setStep(0);
            setInstances([
              {
                scholarAddress: "",
                rewardTokenAddress: "",
                split: "",
                droppedNfts: [],
              },
            ]);
            setCurrentInstance(0);
          }}
          style={{ cursor: "pointer" }}
        />
        {/* <Box
          sx={{
            // height: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Topbar />
        </Box> */}
      </Box>
      <PreviewAndSelectedNfts
        selectedNft={selectedNft}
        setSelectedNft={setSelectedNft}
        setProfileNfts={setProfileNfts}
        setStep={setStep}
        droppedNfts={droppedNfts}
        setDroppedNfts={setDroppedNfts}
        scholarAddress={scholarAddress}
        setScholarAddress={setScholarAddress}
        split={split}
        setSplit={setSplit}
        operation={operation}
        searchVar={searchVar}
        searchShow={searchShow}
        filteredNfts={filteredNfts}
        setFiltered={(e) => {
          const { value } = e.target;
          setSearchVar(value);
          if (value === "") {
            setSearchShow(false);
            setFilteredNfts([]);
          } else {
            const filtered = selectedNft.filter((nft) =>
              nft.name.toLowerCase().includes(value.toLowerCase())
            );

            setFilteredNfts(filtered);
            setSearchShow(true);
          }
        }}
        instances={instances}
        addInstance={addInstance}
        updateInstance={updateInstance}
        removeInstance={removeInstance}
        setInstances={setInstances}
        currentInstance={currentInstance}
        setCurrentInstance={setCurrentInstance}
        type={type}
      />
    </Box>
  );
};
